import { render, staticRenderFns } from "./MenuObras.vue?vue&type=template&id=bb35f532&scoped=true&"
import script from "./MenuObras.vue?vue&type=script&lang=js&"
export * from "./MenuObras.vue?vue&type=script&lang=js&"
import style0 from "./MenuObras.vue?vue&type=style&index=0&id=bb35f532&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb35f532",
  null
  
)

export default component.exports